module.exports = __webpack_public_path__ + "static/media/Primary.4a4170ce.png";